<script setup>
import {computed} from 'vue'
import {useViewStore} from '@/stores/view'
import {useAppStore} from '@/stores/appStore'
import AttachmentDropzone from '@/common/AttachmentDropzone.vue'

const props = defineProps({
    options: {
        type: Object,
        default: () => ({})
    }
})

defineEmits(['hide-modal'])

const appStore = useAppStore()

const modalTitle = computed(() => props.options.modalTitle || 'Bulk Upload')

const setFile = (obj) => {
    const viewId = appStore.mainViewId
    if (viewId) {
        const viewStore = useViewStore(viewId)
        viewStore.scheduleLoad()
    }
}
</script>

<template>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{{ modalTitle }}</h4>
                <button
                    type="button"
                    class="btn-close"
                    aria-label="Close"
                    @click="$emit('hide-modal')"
                ></button>
            </div>

            <div class="modal-body">
                <AttachmentDropzone
                    :set-file="setFile"
                    :multiple="true"
                />
            </div>
        </div>
    </div>
</template>

<style scoped>
/* Optional: ensure the dropzone has enough height inside the modal */
.modal-body {
    min-height: 200px;
}
</style>